import React from "react";
import { Link } from "react-router-dom";

const ProductItem = ({ href, imageSrc, stepNumber, title, description }) => {
    console.log("href ", href);
    
    return (
        <Link to={href}>
            <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                    <img src={imageSrc} alt="" className="card-img-top" />
                    <div className="position-absolute text-overlay text-white p-3">
                        <h1 className="fw-bold opacity-50" style={{ fontSize: "3rem" }}>{stepNumber}</h1>
                        <h6 className="fw-bold">{title}</h6>
                        <p className="small" style={{ fontSize: "11px" }}>
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default ProductItem;


